module.exports = __webpack_public_path__ + "img/num_47.74498c6d.png";